/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {useRef} from 'react';
import {useSelector} from 'react-redux';
import {getAccountById} from '@ion/core/src/entities/Accounts';
import {AccountLink} from '@ion/core/src/types/entities';
import {globalGroupAccountHierarchySelector} from '../store/selectors/global-group';

export interface UseAccountInHierarchyResult {
  getAccount: (accountId: number) => AccountLink | null;
}

export type AccountRef = {
  id: number,
  account: AccountLink
}

/**
 * Hook holding helpers for working with accounts in the account hierarchy
 * @returns helpers for working with an account
 */
export const useAccountInHierarchy = (): UseAccountInHierarchyResult => {
  const hierarchy = useSelector(globalGroupAccountHierarchySelector);
  const result    = useRef<AccountRef | null>();

  const getAccount = (accountId: number): AccountLink | null => {
    if (!result.current || result.current.id !== accountId) {
      result.current = {
        account : getAccountById(hierarchy, accountId),
        id      : accountId
      };
    }
    return result.current.account;
  };
  return {
    getAccount
  };
};
export default useAccountInHierarchy;
